import { Suspense, useEffect } from "react";
import Router from "./router";
import ErrorBoundary from "./components/ErrorBoundary";
import LoadingSpinner from "./components/LoadingSpinner";
import { useAppStore } from "./stores/appStore";

function App() {
  const bootstrap = useAppStore((s) => s.bootstrap);

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-ink text-paper">
        <Suspense fallback={<LoadingSpinner />}>
          <Router />
        </Suspense>
      </div>
    </ErrorBoundary>
  );
}

export default App;
